var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellYourServicesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.448,
    height: 38.41,
    viewBox: "0 0 46.448 38.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customer-service_2_",
    "data-name": "customer-service (2)",
    transform: "translate(-5.232 -12.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M29.054,12.124A18.273,18.273,0,0,0,10.893,25.286a2.967,2.967,0,0,0-1.177.109,6.023,6.023,0,0,0-3.61,3.151,10.661,10.661,0,0,0-.74,5.989A9.121,9.121,0,0,0,7.8,39.7a4.1,4.1,0,0,0,3.808,1.223c1.956-.418,2.926-.73,2.652-2.553l-1.326-8.835a15.542,15.542,0,0,1,31.036.021l-.927,6.18a15.528,15.528,0,0,1-13.13,10.138H25.964a1.837,1.837,0,0,0-1.841,1.84v.971a1.837,1.837,0,0,0,1.841,1.84h4.982a1.834,1.834,0,0,0,1.837-1.84v-.507A18.342,18.342,0,0,0,43.706,40.5l1.6.423A3.969,3.969,0,0,0,49.111,39.7a9.126,9.126,0,0,0,2.436-5.164,10.732,10.732,0,0,0-.739-5.989,5.2,5.2,0,0,0-3.163-3.032,6.772,6.772,0,0,0-1.633-.228A18.271,18.271,0,0,0,29.054,12.124Z",
    fill: "#e4d85d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M42.421,32.043a2.388,2.388,0,1,1-2.391,2.388A2.39,2.39,0,0,1,42.421,32.043Zm-6.43,0A2.388,2.388,0,1,1,33.6,34.431,2.386,2.386,0,0,1,35.992,32.043Zm-6.427,0a2.388,2.388,0,1,1-2.388,2.388A2.388,2.388,0,0,1,29.564,32.043Zm6.427-10.256a12.7,12.7,0,0,0-9.213,21.385l-.755,3.382c-.249,1.113.523,1.862,1.524,1.3l3.3-1.842a12.868,12.868,0,0,0,5.141,1.058,12.644,12.644,0,0,0,0-25.288Z",
    transform: "translate(-7.536 -4.024)",
    fill: "#e4d85d",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellYourServicesIcon);
export default __webpack_public_path__ + "static/media/Sell Your Services_icon.d6c9e7860f32bc7c3168578f6c36b602.svg";
export { ForwardRef as ReactComponent };